module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chargeDetail"
    }
  }, [_c('p', {
    staticClass: "chargeDetai_p"
  }, [_vm._v("抓药详情")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "infomation"
  }, [_c('div', {
    staticClass: "Headpic"
  }, [_c('img', {
    attrs: {
      "src": this.patientBaseEntity.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(this.patientBaseEntity.name))]), _vm._v(" "), _c('div', {
    staticClass: "in-table"
  }, [_c('div', {
    staticClass: "in-tabOne"
  }, [_c('h2', [_vm._v("性别:"), _c('span', [_vm._v(_vm._s(this.patientBaseEntity.gender))])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tabTow"
  }, [_c('h2', [_vm._v("周岁:"), _c('span', [_vm._v(_vm._s(this.patientBaseEntity.age))])])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tel"
  }, [_c('h2', [_vm._v("电话:"), _c('span', [_vm._v(_vm._s(this.patientBaseEntity.mobileNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tel"
  }, [_c('h2', [_vm._v("订单状态:"), _c('span', [_vm._v(_vm._s(this.medicineInfo.orderStatusName))])])]), _vm._v(" "), _c('div', {
    staticClass: "in-tel"
  }, [_c('h2', [_vm._v("抓药时间:"), _c('span', [_vm._v(_vm._s(this.medicineInfo.getMedicineDateTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list_p"
  }, [_vm._v("详情")]), _vm._v(" "), _c('el-collapse', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.tablevalue), function(item, index) {
    return _c('el-collapse-item', {
      key: item.id,
      staticStyle: {
        "text-indent": "10px"
      },
      attrs: {
        "title": item.recipeName + '、' + item.quantity + '副、' + item.eatType,
        "name": index
      }
    }, [
      [_c('el-table', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "data": item.recipeItemResponseList,
          "border": "",
          "header-cell-style": _vm.tableHeaderColor
        }
      }, [_c('el-table-column', {
        attrs: {
          "prop": "medicineName",
          "label": "药品名称"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "prop": "medicineNumber",
          "label": "数量",
          "width": "150"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "prop": "stockNumber",
          "label": "当前库存",
          "width": "150"
        }
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "label": "历史余量",
          "width": "150"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var row = ref.row;

            return [_vm._v("\n                                        " + _vm._s([2, 5].includes(_vm.status) ? row.residualNumber : '') + "\n                                    ")]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        attrs: {
          "prop": "medicineUnit",
          "label": "单位",
          "width": "150"
        }
      })], 1)], _vm._v(" "), _c('div', [_vm._v("\n                              忌口及日常护理：\n                            "), _c('el-input', {
        class: {
          input1: _vm.active
        },
        attrs: {
          "type": "textarea",
          "autosize": "",
          "disabled": true
        },
        model: {
          value: (item.note),
          callback: function($$v) {
            _vm.$set(item, "note", $$v)
          },
          expression: "item.note"
        }
      })], 1)
    ], 2)
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status == 4),
      expression: "status==4"
    }]
  }, [_vm._v("\n                      邮寄地址：\n                    "), _c('el-input', {
    class: {
      input3: _vm.active
    },
    attrs: {
      "type": "textarea",
      "autosize": "",
      "disabled": true
    },
    model: {
      value: (this.medicineInfo.mailAddress),
      callback: function($$v) {
        _vm.$set(this.medicineInfo, "mailAddress", $$v)
      },
      expression: "this.medicineInfo.mailAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status == 5),
      expression: "status==5"
    }]
  }, [_vm._v("\n                      邮寄地址：\n                    "), _c('el-input', {
    class: {
      input3: _vm.active
    },
    attrs: {
      "type": "textarea",
      "autosize": "",
      "disabled": true
    },
    model: {
      value: (this.medicineInfo.mailAddress),
      callback: function($$v) {
        _vm.$set(this.medicineInfo, "mailAddress", $$v)
      },
      expression: "this.medicineInfo.mailAddress"
    }
  })], 1), _vm._v(" "), (this.$route.query.data) ? _c('div', {
    staticClass: "button"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status == 1),
      expression: "status==1"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确认抓药")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status == 4),
      expression: "status==4"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("确认邮寄")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "./medicine_list"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e(), _vm._v(" "), (this.$route.query.Data) ? _c('div', {
    staticClass: "button"
  }, [_c('router-link', {
    attrs: {
      "to": "./medicine_list"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    }
  }, [_vm._v("返回")])], 1)], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55e7c046","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/medicine/medicineDetail.vue
// module id = 1020
// module chunks = 2